export default __webpack_public_path__ + "static/media/grab.19e16ab8.jpg";